import { render, staticRenderFns } from "./ClassLogo.vue?vue&type=template&id=46f4184c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f4184c')) {
      api.createRecord('46f4184c', component.options)
    } else {
      api.reload('46f4184c', component.options)
    }
    module.hot.accept("./ClassLogo.vue?vue&type=template&id=46f4184c&", function () {
      api.rerender('46f4184c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/ClassLogo.vue"
export default component.exports